import { Grid, Typography } from "@material-ui/core";
import AcademicYearInput from "components/AcademicYearInput";
import AddressAutoCompleteInput from "components/AddressAutoCompleteInput";
import CustomStudentScheduleDateInput from "components/CustomStudentScheduleDateInput";
import DaysOfWeekInput from "components/DaysOfWeekInput";
import { RadioButtonGroupInput, TextInput, required } from "react-admin";

interface IStudentCreateRegularProps {
  setIdAcademicYear: (value: number) => void;
  academicYearResources: any;
  includeDates: IIncludeDates[];
  excludeDates: IExcludeDates[];
}
export const StudentCreateRegular = ({
  setIdAcademicYear,
  academicYearResources,
  includeDates,
  excludeDates,
}: IStudentCreateRegularProps) => {
  return (
    <>
      <Grid
        xs={12}
        style={{
          backgroundColor: "#fffffc",
          padding: "24px 34px",
          border: "1px solid #e8e2a7",
          borderRadius: 12,
        }}
      >
        <Grid item xs={12} style={{ marginBottom: "10px" }}>
          <Typography variant="h6">Regular Schedule</Typography>
        </Grid>

        <Grid item xs={4}>
          <AcademicYearInput parentCallback={setIdAcademicYear} />
        </Grid>

        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <CustomStudentScheduleDateInput
            source="startedAt"
            label="Start Date *"
            referenceSource={academicYearResources}
            includeDates={includeDates}
            excludeDates={excludeDates}
          />
        </Grid>

        <Grid item xs={12}>
          <RadioButtonGroupInput
            label="To and/or From"
            source="toAndFrom"
            choices={[
              { id: "OneWayMorning", name: "Morning (Bus to School)" },
              {
                id: "OneWayAfternoon",
                name: "Afternoon (Bus from School)",
              },
              { id: "TwoWay", name: "Both" },
            ]}
            validate={required()}
          />
        </Grid>

        <DaysOfWeekInput />

        <Grid item xs={12} style={{ marginBottom: "10px" }}>
          <Typography variant="h6">Pick up & Drop off Address</Typography>
        </Grid>

        <Grid item xs={4}>
          <AddressAutoCompleteInput
            label="Postal Code *"
            source="postalCode"
            referenceSource="locationData"
          />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={2}>
          <TextInput label="Unit No." source="unitNumber" />
        </Grid>
        <Grid item xs={2}>
          <TextInput label="Block No." source="blockNumber" />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <TextInput label="Building Name" source="building" />
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <TextInput label="Street" source="street" validate={required()} />
        </Grid>
        <Grid item xs={8}></Grid>
      </Grid>
    </>
  );
};
